"use client";
const e = Object.freeze({
  h1: "400",
  h2: "700",
  h3: "700",
  h4: "700"
}), t = Object.keys(e);
export {
  e as HEADING_WEIGHTS,
  t as HEADING_WEIGHT_KEYS
};
